import {
  Card,
  Image,
  Progress,
  Button,
  Stack,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { ICourse } from '../../../interfaces/ICourse';
import classes from './CourseCard.module.css';
import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';
import { getShopProductUrl } from '../../../utils/shopUrl';

interface CourseCardProps {
  course: ICourse;
}

export function CourseCard({ course }: CourseCardProps) {
  const progress = course.progress_percentage ?? 0;
  const isPurchased = course.unlocked;
  const isCompleted = course.completed;
  const theme = useMantineTheme();

  const getButtonText = () => {
    if (!isPurchased) return 'Acquista';
    if (progress === 0) return 'Inizia';
    if (isCompleted) return 'Completato';
    return 'Continua';
  };

  const handleCardClick = () => {
    if (isPurchased) {
      // Naviga internamente
      window.location.href = `/proCourses/${course.id}`;
    } else {
      window.open(
        getShopProductUrl(course.slug),
        '_blank',
        'noopener,noreferrer'
      );
    }
  };

  return (
    <Card
      shadow='sm'
      withBorder
      p={{ base: 5, sm: 'xs' }}
      radius='sm'
      miw={{ base: 110, sm: 130, md: 150, lg: 170 }}
      className={classes.card}
      onClick={handleCardClick}
    >
      <Card.Section>
        <Image
          src={course.image}
          alt={course.name}
          h={{ base: 110, sm: 130, md: 150, lg: 170 }}
          fit='contain'
        />
      </Card.Section>
      <Stack gap='xs' mt='sm'>
        {isPurchased ? (
          <>
            <Progress.Root size='md'>
              <Progress.Section
                value={progress}
                color={isCompleted ? 'green' : theme.primaryColor}
              />
            </Progress.Root>
            <Text size='xs' c='dimmed'>
              Progresso: {Math.round(progress)}%
            </Text>
            <Button
              variant='light'
              color={isCompleted ? 'green' : theme.primaryColor}
              component={Link}
              to={`/proCourses/${course.id}`}
              fullWidth
              onClick={e => e.stopPropagation()}
            >
              {getButtonText()}
            </Button>
          </>
        ) : (
          <Button
            leftSection={<Info size={16} />}
            variant='outline'
            fullWidth
            onClick={e => {
              e.stopPropagation();
              window.open(
                getShopProductUrl(course.slug),
                '_blank',
                'noopener,noreferrer'
              );
            }}
            radius='sm'
          >
            Sblocca
          </Button>
        )}
      </Stack>
    </Card>
  );
}
